import { createDeferredAction } from '@store/common/actions';
import { httpRequestFactory } from '@store/common/http-request-factory';
import { HttpRequestMethod } from '@store/common/http-request-method';
import { MAIN_API } from '@store/common/path';
import { AxiosResponse } from 'axios';
import { logError } from 'core/sentry';
import { IUpdateBotRequest, IUpdateBotResponse } from 'lingopractices-models/src/main';
import { SagaIterator } from 'redux-saga';
import { call } from 'redux-saga/effects';

export class UpdateUserBot {
  static get action() {
    return createDeferredAction<IUpdateBotRequest>('user_bots/UPDATE_USER_BOT');
  }

  static get saga() {
    return function* ({ payload, meta }: ReturnType<typeof UpdateUserBot.action>): SagaIterator {
      try {
        const { data } = UpdateUserBot.httpRequest.call(
          yield call(() => UpdateUserBot.httpRequest.generator(payload)),
        );

        const { isSuccessful } = data;

        if (!isSuccessful) {
          throw new Error();
        }

        meta?.deferred.resolve(isSuccessful);
      } catch (e: any) {
        meta?.deferred.reject(e);
        logError(e);
      }
    };
  }

  static get httpRequest() {
    return httpRequestFactory<AxiosResponse<IUpdateBotResponse>, IUpdateBotRequest>(
      MAIN_API.USER_BOTS,
      HttpRequestMethod.Put,
    );
  }
}
